export class AlertModel {
  id = '';
  action = '99';
  createdById = 0;
  createdOn: Date;
  contraventions = '';
  documents: any[];
  endDate: Date;
  howOrderedId: number;
   issuedEndDate: Date;
   issuedStartDate: Date;
   alertDefinition: string;
   instructions = '';
   explanation = '';
   letterTypeId: number;
   modifiedById: number;
   modifiedOn: Date;
   locations = '';
  name = '';
  orderingClient = '';
  paragraphAutoSelect:  boolean;
  paragraphLocationId: number;
  pcnNumbers = '';
  pcnTypes: any[];
  policies: any[];
   proofText = '';
  reasons: any[];
  receivingPerson = '';
  reference = '';
  registrationNumbers = '';
  stages: any[];
  startDate: Date;
  timesAccepted = 0;
  timesDisplayed = 0;
  whenOrdered: Date;
  decisionId: number;
  decisionName = '';
  selected = false;
  eventCode: string;
}
